import { ActivityItemProps } from "../../interfaces/ActivityInterface";
import SectionHeader from "../../components/SectionHeader";
import ActivityItem from "../../components/ActivityItem";
import FilterActivity from "../components/FilterActivity";
import HamburgerMenu from "../../../public/assets/hamburger-menu.svg";
import styles from "../styles/ActivityList.module.scss";
import React, { useState } from "react";
import { partyUseCase } from "../../lib/dependencies";

export default function ActivityList({
  activities,
  setActivityDetail,
}: {
  activities: ActivityItemProps[];
  setActivityDetail: (toggleStatus: number, id: string) => void;
}) {
  const [toggledFilter, setToggledFilter] = useState(false);
  function handleToggleFilter() {
    setToggledFilter(!toggledFilter);
  }

  return (
    <div>
      <div className={styles.header_container}>
        <div className={styles.filter}>
          <HamburgerMenu
            className={styles.filter_icon}
            onClick={handleToggleFilter}
          ></HamburgerMenu>
          <p>FILTER ACTIVITY</p>
        </div>
        <SectionHeader className={styles.header}>ACTIVITIES</SectionHeader>
      </div>
      <div className={styles.body_container}>
        <div
          className={`${styles.filter_activity} ${
            toggledFilter && styles.show
          }`}
        >
          <FilterActivity></FilterActivity>
        </div>
        <div
          className={`${styles.activities} ${
            toggledFilter && styles.activities_shrink
          }`}
        >
          {activities.map((value, index) => {
            return (
              <ActivityItem
                key={index}
                className={styles.activity}
                activity={value}
                setActivityDetail={setActivityDetail}
                // getAllPartiseOfActivitiy ={getAllPartiesOfActivity}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
